

import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, take, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  public apiUrl: string = environment.apiUrl;

  public httpClient = inject(HttpClient);

  private getAuthHeaders(): { headers: Record<string, string> } {
    const token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : { headers: {} };
  }

  httpGet<T>(endpoint: string, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.get<T>(`${this.apiUrl}${endpoint}`, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.get<T>(`${this.apiUrl}${endpoint}`, options ?? {});
  }

  httpPost<T>(endpoint: string, body: any, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.post<T>(`${this.apiUrl}${endpoint}`, body, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.post<T>(`${this.apiUrl}${endpoint}`, body, options ?? {});
  }
  
  httpPostFullRoute<T>(endpoint: string, body: any, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.post<T>(`${endpoint}`, body, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.post<T>(`${endpoint}`, body, options ?? {});
  }

  httpPut<T>(endpoint: string, body: any, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.put<T>(`${this.apiUrl}${endpoint}`, body, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.put<T>(`${this.apiUrl}${endpoint}`, body, options ?? {});
  }

  httpPatch<T>(endpoint: string, body: any, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.patch<T>(`${this.apiUrl}${endpoint}`, body, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.patch<T>(`${this.apiUrl}${endpoint}`, body, options ?? {});
  }

  httpDelete<T>(endpoint: string, auth?: boolean, options?: Record<string, any>): Observable<T> {
    if (auth) {
      const token = localStorage.getItem('token');
      if (!token) {
        return new Observable<T>(observer => {
          observer.error(new Error('No auth token found'));
        });
      }
      return this.httpClient.delete<T>(`${this.apiUrl}${endpoint}`, { ...(options ?? {}), ...this.getAuthHeaders() });
    }
    return this.httpClient.delete<T>(`${this.apiUrl}${endpoint}`, options ?? {});
  }

}
